import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {openUploadWindow} from '@common/uploads/utils/open-upload-window';
import {UploadQueueService} from '@common/uploads/upload-queue/upload-queue.service';
import {UploadInputTypes} from '@common/uploads/upload-input-config';
import {UploadUri} from '@common/uploads/types/upload-uri.enum';
import {AppearanceImageUploadValidator} from '@common/admin/appearance/appearance-image-input/appearance-image-upload-validator';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

type propagateFn = (url: string) => void;

@Component({
    selector: 'link-thumbnail-panel',
    templateUrl: './link-thumbnail-panel.component.html',
    styleUrls: ['./link-thumbnail-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [UploadQueueService,  {
        provide: NG_VALUE_ACCESSOR,
        useExisting: LinkThumbnailPanelComponent,
        multi: true,
    },],
})
export class LinkThumbnailPanelComponent implements OnInit, ControlValueAccessor {
    src$ = new BehaviorSubject<string>(null);
    private propagateChange: propagateFn;

    constructor(
        private uploadQueue: UploadQueueService,
        private imageValidator: AppearanceImageUploadValidator,
    ) {}

    ngOnInit(): void {}

    registerOnChange(fn: propagateFn) {
        this.propagateChange = fn;
    }

    writeValue(value: string) {
        this.src$.next(value);
    }

    registerOnTouched(fn: any) {}

    openUploadWindow() {
        openUploadWindow({
            multiple: false,
            types: [UploadInputTypes.image],
        }).then(files => {
            const config = {
                httpParams: {diskPrefix: 'biolink-thumbnails'},
                uri: UploadUri.Image,
                validator: this.imageValidator,
            };
            this.uploadQueue.start(files, config).subscribe(response => {
                this.src$.next(response.fileEntry.url);
                this.propagateChange(response.fileEntry.url);
            });
        });
    }

    removeImage() {
        this.src$.next(null);
        this.propagateChange(null);
    }
}
